import { Route } from '@angular/router'

export const IMPORT: Route[] = [
    {
        path: '',
        loadComponent: () =>
            import('./features/import/import.page').then((c) => c.ImportPage),
    },
    {
        path: 'session/:id',
        loadComponent: () =>
            import('./features/import/import-session/import-session.page').then(
                (c) => c.ImportSessionPage
            ),
    },
]
